const tocScroll = ( tocHeadings, notificationBarWrapper, insightInnerAside ) => {
  $( tocHeadings ).each( ( i, heading ) => {
    $( heading ).on( 'click', e => {
      e.preventDefault();
      const notificationBarWrapperHeight = $( notificationBarWrapper ).height();
      const selectedHeading = $( $( heading ).attr( 'href' ) );

      $( insightInnerAside ).css( { top: 136 + notificationBarWrapperHeight } );
      $( tocHeadings ).removeClass( 'active' );
      $( heading ).addClass( 'active' );

      if ( selectedHeading.length ) {
        const windowWidth = $( window ).width();
        const headingCoords = selectedHeading[0].getBoundingClientRect();

        if ( windowWidth < 769 ) {
          window.scrollTo( {
            left: headingCoords?.left + window.scrollX,
            top: headingCoords?.top + window.scrollY - 90 - notificationBarWrapperHeight,
            behavior: 'smooth',
          } );
        } else {
          window.scrollTo( {
            left: headingCoords?.left + window.scrollX,
            top: headingCoords?.top + window.scrollY - 120 - notificationBarWrapperHeight,
            behavior: 'smooth',
          } );
        }
      }
    } );
  } );
};

$( $ => {
  const tocHeadings = $( '.bs-div--insight-inner-toc ul li a' );
  if( tocHeadings.length === 0 ) return;

  const notificationBarWrapper = $( '.notification-top-bar__wrapper' );
  const insightInnerAside = $( '.bs-div--insight-inner-aside' );
  const taxonomyTags = $( '.taxonomy-post_tag' );
  const hTags = $( '.bs-section--insight-inner-content .bs-column:nth-of-type(2) :header' );

  const asidePosition = wh => $( insightInnerAside ).css( { top: 136 + wh } );

  if ( insightInnerAside.length && tocHeadings.length ) {
    asidePosition( $( notificationBarWrapper ).height() );
    tocScroll( tocHeadings, notificationBarWrapper, insightInnerAside );

    // Title active handler
    const options = {
      threshold: 0,
      rootMargin: '-200px 0px -60% 0px',
    };
    const observer = new IntersectionObserver( entries => {
      entries.forEach( entry => {
        const currentId = `#${entry.target.id}`;

        tocHeadings.each( ( index, elm ) => {
          if (
            entry.isIntersecting &&
            currentId == $( elm ).attr( 'href' ) &&
            !window.matchMedia( '(max-width: 991.98px)' ).matches
          ) {
            $( tocHeadings ).removeClass( 'active' );
            $( elm ).addClass( 'active', entry.isIntersecting );
          }
        } );
      } );
    }, options );
    hTags.each( ( index, hTag ) => {
      observer.observe( hTag );
    } );
  } else {
    $( '.bs-div--insight-inner-toc .bs-div' ).hide();
  }
  // Tags show/hide handler
  !taxonomyTags.length && $( '.bs-div--insight-inner-tags' ).hide();
} );